import { Link, Outlet } from "react-router";
import { useAuth } from "@/lib/auth";

export function Layout(): React.ReactElement {
  const { isAuthenticated, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-y-2 px-4 py-3">
          <Link to="/" className="text-xl font-bold text-gray-900">
            VendorPay
          </Link>

          {isAuthenticated && (
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <nav className="flex flex-wrap gap-x-4 gap-y-1">
                <Link
                  to="/roster"
                  className="whitespace-nowrap text-sm font-medium text-gray-600 hover:text-gray-900"
                >
                  My Employees
                </Link>
                <Link
                  to="/roster/new-order"
                  className="whitespace-nowrap text-sm font-medium text-gray-600 hover:text-gray-900"
                >
                  New Order
                </Link>
                <Link
                  to="/orders"
                  className="whitespace-nowrap text-sm font-medium text-gray-600 hover:text-gray-900"
                >
                  Receipts
                </Link>
              </nav>
              <button
                type="button"
                onClick={logout}
                className="text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
